module.exports = __webpack_public_path__ + "img/b615f61.jpg";